import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormDesignerModule } from './form-designer';
import { FormRenderModule } from './form-render';
import { DSharedModule } from './shared';
// abp module
const ALL_MODULES: Type<any>[] = [CommonModule, FormDesignerModule, FormRenderModule, DSharedModule];

@NgModule({
  imports: [...ALL_MODULES],
  declarations: [],
  entryComponents: [],
  exports: [...ALL_MODULES],
  providers: []
})
export class L52AbpFormGeneratorModule {}
